import React from 'react';

const tier = (score) => {
  if (score >= 90) return { label: 'Elite',             tone: 'border-[#C8A96B] bg-[#C8A96B] text-[#050505]' };
  if (score >= 80) return { label: 'Trusted',           tone: 'border-[#C8A96B] bg-transparent text-[#DCBE82]' };
  if (score >= 70) return { label: 'Verified Baseline', tone: 'border-[rgba(255,255,255,0.18)] bg-transparent text-[#B8B2A2]' };
  return                  { label: 'Emerging',          tone: 'border-[rgba(255,255,255,0.18)] bg-transparent text-[#8A8579]' };
};

export const TrustScore = ({ score, variant = 'inline' }) => {
  const t = tier(score);
  if (variant === 'inline') {
    return (
      <div data-testid="trust-score-inline" className="flex items-center gap-2">
        <div className="font-mono-data text-lg font-semibold text-platinum">{score}<span className="text-platinum-2 text-xs">/100</span></div>
        <span className={`label-overline inline-flex items-center rounded-full border px-3 py-1 ${t.tone}`}>{t.label}</span>
      </div>
    );
  }
  // Large architectural display
  return (
    <div data-testid="trust-score-large" className="border border-black p-6">
      <div className="label-overline text-neutral-500">Giwahs Trust Score</div>
      <div className="mt-3 flex items-end gap-3">
        <div className="font-display leading-none tracking-tighter" style={{ fontSize: '5rem', fontWeight: 700 }}>{score}</div>
        <div className="pb-3 font-mono-data text-sm text-neutral-500">/100</div>
      </div>
      <div className="mt-4 h-1.5 w-full bg-neutral-200">
        <div className="h-full bg-black" style={{ width: `${score}%` }} />
      </div>
      <div className="mt-3 flex items-center justify-between">
        <span className={`label-overline inline-flex items-center rounded-full px-3 py-1 ${t.tone}`}>{t.label}</span>
        <span className="font-mono-data text-[10px] text-neutral-500">ILLUSTRATIVE</span>
      </div>
    </div>
  );
};

export default TrustScore;
